<template>
  <div>
    <p class="subtitle">Video & Audio</p>
    <div class="settings_line">
      <p>
        Microphone
        <template v-if="allMicrophones.length === 0">
          <br />
          No microphone found
        </template>
      </p>

      <dropDown
        v-if="allMicrophones.length > 0"
        :default_item="allMicrophones[0].label"
        :with_img="true"
        :src="require(`@/assets/img/settings_mic_icon.svg`)"
        :options="allMicrophones"
        @setDevice="getMic"
      ></dropDown>
    </div>

    <div class="settings_line">
      <p>
        Camera
        <template v-if="allCameras.length === 0">
          <br />
          No camera found
        </template>
      </p>

      <dropDown
        v-if="allCameras.length > 0"
        :default_item="allCameras[0].label"
        :with_img="true"
        :src="require(`@/assets/img/settings_camera_icon.svg`)"
        :options="allCameras"
        @setDevice="getCamera"
      ></dropDown>
    </div>
  </div>
</template>

<script>
import dropDown from "@/components/dropDown.vue";

export default {
  name: "Devices",
  data() {
    return {
      selectedCameraId: "",
      selectedMicrophoneId: "",
    };
  },

  components: {
    dropDown,
  },

  watch: {
    currentCamera: {
      immediate: true,
      handler(newVal) {
        this.selectedCameraId = newVal?.deviceId || "";
      },
    },
    currentMicrophone: {
      immediate: true,
      handler(newVal) {
        this.selectedMicrophoneId = newVal?.deviceId || "";
      },
    },
  },

  methods: {
    getCamera(setDevice) {
      this.selectedCameraId = setDevice;
      this.setCamera(setDevice);
    },

    getMic(setDevice) {
      this.selectedMicrophoneId = setDevice;
      this.setMicrophone(setDevice);
    },

    setCamera(deviceId) {
      this.$store.dispatch("setVideoDevice", deviceId);
    },

    setMicrophone(deviceId) {
      this.$store.dispatch("setAudioDevice", deviceId);
    },
  },

  mounted() {
    /*    this.allCameras.length
        ? this.getCamera(this.allCameras[0].deviceId)
        : "";
    this.getMic(this.allMicrophones[0].deviceId);*/
  },

  computed: {
    currentCamera() {
      return this.$store.state.meeting.currentVideo;
    },

    currentMicrophone() {
      return this.$store.state.meeting.currentAudio;
    },

    allCameras() {
      return this.$store.state.meeting.videoDevices;
    },

    allMicrophones() {
      return this.$store.state.meeting.audioDevices;
    },
  },
};
</script>

<style lang="scss" scoped></style>
